// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingOverlay-m_VYbeqkvM0cx1N1pLeEZE {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    z-index: 9999;
    justify-content: center;
    align-items: center;
  }

  .LoadingOverlay-m_C8XvOwDNPPiirBhNmVw5 {
    background-color: white;
    border-radius: 5px;
    padding: 2rem;
    min-width: 20%;
    color: var(--text);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .LoadingOverlay-m_cXec6ssaERmgwOS9N7xB {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  
  .LoadingOverlay-m_cXec6ssaERmgwOS9N7xB div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 5px solid var(--pies-blue);
    border-radius: 50%;
    animation: LoadingOverlay-m_AIM10AevF1PhMgh4Cu2F 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--pies-blue) transparent transparent transparent;
  }
  
  .LoadingOverlay-m_cXec6ssaERmgwOS9N7xB div:nth-child(1) {
    animation-delay: -0.45s;
  }
  
  .LoadingOverlay-m_cXec6ssaERmgwOS9N7xB div:nth-child(2) {
    animation-delay: -0.3s;
  }
  
  .LoadingOverlay-m_cXec6ssaERmgwOS9N7xB div:nth-child(3) {
    animation-delay: -0.15s;
  }
  
  @keyframes LoadingOverlay-m_AIM10AevF1PhMgh4Cu2F {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }
  
`, "",{"version":3,"sources":["webpack://./client/shared/genericComponents/LoadingOverlay/LoadingOverlay.m.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,2FAA8D;IAC9D,kEAAkE;EACpE;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    display: flex;\n    z-index: 9999;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container {\n    background-color: white;\n    border-radius: 5px;\n    padding: 2rem;\n    min-width: 20%;\n    color: var(--text);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .loadingSpinner {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n  }\n  \n  .loadingSpinner div {\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    width: 64px;\n    height: 64px;\n    margin: 8px;\n    border: 5px solid var(--pies-blue);\n    border-radius: 50%;\n    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    border-color: var(--pies-blue) transparent transparent transparent;\n  }\n  \n  .loadingSpinner div:nth-child(1) {\n    animation-delay: -0.45s;\n  }\n  \n  .loadingSpinner div:nth-child(2) {\n    animation-delay: -0.3s;\n  }\n  \n  .loadingSpinner div:nth-child(3) {\n    animation-delay: -0.15s;\n  }\n  \n  @keyframes lds-ring {\n    0% {\n      transform: rotate(0deg);\n    }\n  \n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
export var overlay = `LoadingOverlay-m_VYbeqkvM0cx1N1pLeEZE`;
export var container = `LoadingOverlay-m_C8XvOwDNPPiirBhNmVw5`;
export var loadingSpinner = `LoadingOverlay-m_cXec6ssaERmgwOS9N7xB`;
export var ldsRing = `LoadingOverlay-m_AIM10AevF1PhMgh4Cu2F`;
export default ___CSS_LOADER_EXPORT___;
